import { render, staticRenderFns } from "./ModuleCoinbaseUnstaking.vue?vue&type=template&id=51aac47d&scoped=true"
import script from "./ModuleCoinbaseUnstaking.vue?vue&type=script&lang=js"
export * from "./ModuleCoinbaseUnstaking.vue?vue&type=script&lang=js"
import style0 from "./ModuleCoinbaseUnstaking.vue?vue&type=style&index=0&id=51aac47d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51aac47d",
  null
  
)

export default component.exports